var _defs, _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1Pocket01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none;}.cls-2,.cls-1,.cls-0{stroke:#010101;stroke-miterlimit:10;}.cls-2,.cls-0{stroke-width:3px;}.cls-1,.cls-0{fill:#fff;}.cls-1{stroke-dasharray:3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.87,160.58V358.86a43.73,43.73,0,0,1-43.72,43.72H125.59a43.73,43.73,0,0,1-43.72-43.72V160.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.59,399.58a40.77,40.77,0,0,1-40.72-40.72V163.58h263V358.86a40.77,40.77,0,0,1-40.72,40.72Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-0",
    x: 81.87,
    y: 108.58,
    width: 269,
    height: 52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.87,
    y: 111.58,
    width: 263,
    height: 46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Pocket01);
export default __webpack_public_path__ + "static/media/1 POCKET-01.cfdf717fb50a90e308f02e149e4d2430.svg";
export { ForwardRef as ReactComponent };